<template>
    <div class="blogs bg-white">
      <div class="container mx-auto flex gap-4 flex-col lg:py-16 py-10 px-3 ">
        <div class="text-primary text-center font-semibold lg:text-base text-sm">THINGS TO READ</div>
        <div class="md:py-3 py-1 flex justify-center w-full">
          <h1 class="text-center text-2xl lg:text-4xl font-semibold lg:w-3/4">Mastering Comfort: Plumbing and Heating Insights, Tips, Innovations, and Beyond
          </h1>
        </div>
        <hr class="md:my-3" color="grey-4" />
        <div class="md:py-3 py-1 mb-4 md:mb-0" v-if="current_blog">
          <div class="grid grid-cols-12 lg:gap-5 gap-2 py-3 rounded-xl md:shadow-none shadow-md w-full">
            <div class="md:col-span-6 col-span-12 rounded-2xl lg:max-h-[300px] max-h-[250px] sm:max-h-full  w-full lg:p-5 " style="box-shadow: 0 0 5px rgba(198, 198, 198,0.6);">
              <img :src="current_blog?.images[0]" class="rounded-2xl w-full h-full" />
            </div>
            <div class="flex flex-col gap-2 md:gap-4 md:col-span-6 col-span-12 justify-between lg:p-4 p-1">
              <div class="text-primary md:text-base text-sm">{{ current_blog?.category }}</div>
              <div class="md:text-3xl text-xl font-semibold hover:text-blue-500">
                <router-link :to="{name: 'blog-details', params:{slug: current_blog?.slug}}">{{ current_blog?.title }}
                </router-link>
              </div>
              <div class="text-base md:block hidden">
                {{ current_blog?.heading?.slice(0,250) }}...
              </div>
              <div class="flex md:justify-start justify-between gap-5 opacity-60">
                <div class="flex items-center gap-1">
                  <img :src="require('../../assets/v-1.1/Blogs/person.svg')" width="20" height="20" class="opacity-40" />
                  {{ current_blog?.author }}
                </div>
                <div class="">{{ current_blog?.posted_on }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 gap-5 lg:mt-5">
          <div class="rounded-2xl p-4 group hover:scale-105 duration-300 bg-white" v-for="(item, index) in blogs" :key="index" style="box-shadow: 0 0 5px rgba(198, 198, 198,0.6);">
            <BlogCard :blog="item" />
          </div>
        </div>
      </div>
      <form @submit.prevent="handleSubmit()">
        <div class="sign-in w-full md:py-20 md:px-10 py-10 px-3">
          <div class="container grid grid-cols-12 gap-4 w-full ">
            <div class="lg:col-span-3 col-span-12  font-semibold text-2xl text-center flex justify-center items-center">Stay up to date!  Subscribe</div>
            <div class="lg:col-span-6 md:col-span-8 col-span-12 w-full flex justify-start items-start">
              <div class="flex w-full flex flex-col justify-center">
                <input
                  type="email"
                  class="border-b-2 w-full py-3 px-2 rounded-md bg-gray"
                  placeholder="Email"
                  v-model="formData.email"
                  style="box-shadow: 0 0px 10px rgba(149, 149, 149, 0.5);"
                />
                <p v-if="errors.email" class="text-red-500 text-xs italic">{{ errors.email }}</p>
              </div>
            </div>
            <div class="md:col-span-4 lg:col-span-3 col-span-12 flex justify-start items-start">
              <button type="submit" class="mt-5 md:mt-0 py-3 px-8 bg-primary text-white font-normal flex items-center" style="box-shadow: 0 10px 20px rgba(92, 144, 234, 0.5);">Subscribe</button>
            </div>
          </div>
        </div>
      </form>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import BlogCard from "../cards/BlogCard.vue";
import { BLOGS } from "../../constants/constants";
import Swal from "sweetalert2";
const blogs = ref([]);
const current_blog = ref(null);
onMounted( async ()=> {
  // if (!BlogStore.blogs.length) await BlogStore.blogs
  blogs.value = BLOGS.slice(1);
  current_blog.value = BLOGS[0];
});

const errors = ref({});
const formData = ref({
  email: "",
});
const validateForm = () => {
  errors.value = {};
  if (!formData.value.email) {
    errors.value.email = "Email is required.";
  } else if (!isValidEmail(formData.value.email)) {
    errors.value.email = "Please enter a valid email address.";
  };
};

const handleSubmit = () => {
  validateForm();
  if (Object.keys(errors.value).length === 0) {
    Swal.fire(
      "Thank You!",
      "Your response has been submitted successfully. It is very precious for us.",
      "success",
    );
    formData.value.email = "";
    window.scrollTo(0, 0);
  }
};
const isValidEmail = (email) => {
  // Regular expression for email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

</script>
<style setup>
.blogs {
  margin-top: 5.5rem;
}

.sign-in {
  background-image: linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), url('../../assets/v-1.1/Blogs/blogs-main.png'), url('../../assets/v-1.1/Blogs/envelop.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position:  left, right;
}

</style>
